import React, { Component } from 'react';
import { RingLoader } from 'react-spinners'
import { observer } from 'mobx-react';

const EditDirectory = observer ( class EditDirectory  extends Component {
  constructor() {
    super()

    this.mapsApi = process.env.REACT_APP_GEO_API

    this.state = {
      directory: null
    }

    this.onChange = this.onChange.bind(this);
    this.changeAddress = this.changeAddress.bind(this);
    this.readImage = this.readImage.bind(this);
    this.addCategory = this.addCategory.bind(this);
    this.submitUpdate = this.submitUpdate.bind(this);
  }

  componentDidMount () {
    console.log('edit directory', this.props);
    let { directory } = this.props;
    this.setState({directory},() => console.log(this.state))
  }

  onChange(e) {
    let key = e.target.name
	  let val = e.target.value
    let { directory } = this.state;
    switch (key) {
      case 'business':
      case 'imageUrl':
      case 'phone':
      case 'website':
        directory[key] = val;
        this.setState({directory},()=> console.log( this.state.directory ))
        break;

      default:

    }
  }

  changeAddress(e) {
    let key = e.target.name
	  let val = e.target.value
	  let { directory } = this.state
    directory.address = val;

		// get geoJSON data
		fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+ val +'&key='+ this.mapsApi)
		.then(result => {
			return result.json()
		})
		.then(function(jsonRes) {
      console.log('jsonRes',jsonRes);
			let location = jsonRes.results[0].geometry.location
    	let currentLocation = [location.lng,location.lat]
    	directory.location = {
        type: 'Point',
        coordinates: currentLocation
      }
    	this.setState({directory},() => console.log('address changed',directory))

		}.bind(this))
		.catch(err => console.log('error getting coordinates', err))


	}

  readImage(e){

    console.log(e);
    console.log(e.target.files);
    let { myStores } = this.props;
    let { mainStore } = myStores;
    let { directory } = this.state;

    let files = e.target.files
    let imageUrl = null
    let downloadURL = null

    // stop everything if cancel was clicked and no image
    if(files.length <= 0){
      return
    }


    // if user changes the file grab the recent file
    let file =  files.length > 0 ? files[files.length -1]
                                   : files[0]

    let imageFile = file

    var reader = new FileReader();
    reader.onload = function(e){

      var img = new Image()

      img.onload = function(){

        var canvas = document.createElement("canvas");

        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var MAX_WIDTH = 720;
        var MAX_HEIGHT = 720;
        var width = img.width;
        var height = img.height;

        if (width > height) {

          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

        } else {

          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }

        }

        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext("2d");
        ctx.drawImage(img,0,0,width,height);

        var dataurl = canvas.toDataURL();
				var imageData = dataurl.split(',')[1];

        let filename = directory.business + directory.phone;

				var functionUrl = "https://us-central1-funily-deals.cloudfunctions.net/uploadPromoImage";

				var options = {
					method: "POST",
					body: JSON.stringify({
						title: filename,
						data: imageData
					})
				}

				//  FETCH IMAGE URL
				fetch(functionUrl,options)
				.then(res => res.json())
				.then(function (json) {
          console.log(json);
          let downloadURL = json.url;

          directory.imageUrl = downloadURL;

          this.setState({ directory })

				}.bind(this))
				.catch(err => console.log(err));

      }.bind(this) // image on load

        img.src = e.target.result

    }.bind(this) // reader.onload

      reader.readAsDataURL(file)
  }

  addCategory(e){
		let { directory } = this.state
		let cat = e.target.name

    if(document.getElementById(e.target.id).checked) {
      directory.category[e.target.id] = true;
    } else {
      directory.category[e.target.id] = false;
    }

    this.setState({directory}, ()=> console.log('category', this.state.directory.category))

	}

  submitUpdate() {
    let { directory } = this.state;
    let { myStores } = this.props;
    let { mainStore } = myStores;

    mainStore.updateDirectory(directory);
    this.props.close();
  }

  render() {
    let { directory } = this.state;
    if(directory) {
      return (
        <div style={styles.container}>
          <div style={styles.imgContainer}>
            <img src={ directory.imageUrl } style={ styles.img } />
          </div>
          <div className="form-group">
            <label>Business Name</label>
            <input className='form-control'
                   style={ styles.input }
                   type="text"
                   name='business'
                   value={ directory.business }
                   placeholder={ directory.business }
                   onChange={ this.onChange }
            />
          </div>

          <div className="form-group">
            <label>Address</label>
            <input className='form-control'
                   style={ styles.input }
                   type="text"
                   name="address"
                   value={ directory.address }
                   placeholder={ directory.address }
                   onBlur={ this.changeAddress }
                   onChange={ this.changeAddress }
            />
          </div>

          <div className="form-group">
            <label>Image Link (Preferred) </label>
            <input className='form-control'
                   style={ styles.input }
                   type="text"
                   name="imageUrl"
                   value={ directory.imageUrl }
                   placeholder={ directory.imageUrl }
                   onChange={ this.onChange }
            />
            <hr/>
            <label>Upload Image</label>
            <p className='text-danger'>Only if there is no Image URL available</p>
            <input type="file" onChange={(e) => this.readImage(e)} />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input className='form-control'
                   style={ styles.input }
                   type="text"
                   name="phone"
                   value={ directory.phone }
                   placeholder={ directory.phone }
                   onChange={ this.onChange }
            />
          </div>

          <div className="form-group">
            <label>Website</label>
            <input className='form-control'
                   style={ styles.input }
                   type="text"
                   name="website"
                   value={ directory.website }
                   placeholder={ directory.website }
                   onChange={ this.onChange }
            />
          </div>

          <label>Category</label>
          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={directory.category.play}
                     name='play'
                     id='play' o
                     onChange={this.addCategory} />
              Play
            </label>
          </div>

          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={directory.category.eat}
                     name='eat'
                     id='eat'
                     onChange={this.addCategory} />
              Eat
            </label>
          </div>

          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={directory.category.parents}
                     name='parents'
                     id='parents'
                     onChange={this.addCategory} />
              Parents
            </label>
          </div>

          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={
                       directory.category.hasOwnProperty('park') ?
                        directory.category.park
                       : false
                     }
                     name='park'
                     id='park'
                     onChange={this.addCategory} />
              Park
            </label>
          </div>

          <button
            className='btn btn-default btn-block'
            onClick={ this.props.close }
          >Cancel</button>
          <button
            className='btn btn-danger btn-block'
            onClick={ this.submitUpdate }
          >Submit Update</button>
        </div>
      );
    }

    return (
      <div style={styles.ringCont}>
        <RingLoader color='lightblue' />
      </div>
    )

  }

})

const styles = {
  container: {
    display: 'flex',
    justifyContent: "center",
    flexDirection: 'column',
    width: "100%",
    border: "1px solid lightgrey",
    borderRadius: '10px',
    marginTop: 250,
    marginBottom: 200,
    padding: 25,
    paddingTop: 200,
    boxShadow: '10px 10px 5px grey'
  },
  ringCont: {
		display: 'flex',
		justifyContent: 'center'
	},
  input: {
    width: window.innerWidth * .5
  },
  imgContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  img: {
    height: "100px",
    width: "100px"
  }
}

export default EditDirectory  ;



// WEBPACK FOOTER //
// ./src/components/admin/ToEditDirectory.js